module.exports = __webpack_public_path__ + "img/muangthai-logo.c77c405a.png";